<template>
  <div class="paddingLargeRight paddingLargeLeft">
    <div class="minorTitle">
      Create an Account
    </div>
    <div class="accountMenuFullHeightContainer">
      <CreateAccount />
    </div>
  </div>
</template>

<script>
import CreateAccount from '@/components/Forms/CreateAccount'

export default {
	name: 'CreateAccountCard',
	components: {
		CreateAccount
	},
	data () {
		return {
		}
	},
	computed: {
	},
	methods: {
	}
}

</script>

<style scoped>

</style>
